/**
 * Normalizes a value into the screen segment of a `svcTestId` (`<screen>__<element>--<modifier>`),
 * so a shared component can derive its own ids from the host application name at runtime instead of
 * hard-coding a module name it does not own.
 */
export function toTestIdSlug(value: string | null | undefined, fallback = 'app'): string {
  const slug = (value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');

  return slug || fallback;
}
